"use client";

export default function Impact() {
  return;
}